<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M13 5.5v37a1.5 1.5 0 001.5 1.5 1.5 1.5 0 001.5-1.5v-16l22.1-9.6a1.51 1.51 0 000-2.76l-23-10A1.5 1.5 0 0013 5.5zm3 2.29l17.74 7.71L16 23.21z"/></svg>